"use client";

import { useState } from "react";

import { CarIcon, UserIcon } from "lucide-react";

import { StepNavigation } from "@/components/backoffice/step-navigation";
import {
  VehicleAssignmentStep,
  VehicleAssignmentStepProgress,
} from "@/components/backoffice/cat/vehicle-assignment/vehicle-assignment-step-progress";
import { VehicleAssignmentAvsSteps } from "@/components/backoffice/cat/vehicle-assignment/vehicle-assignment-avs-steps";
import { useStep } from "@/hooks/use-step-handler";

const uiText = {
  placeholder: {
    description: "Foo",
    title: "Foo",
  },
  steps: {
    clientInfo: {
      description: "Informations client",
      title: "Informations client",
    },
  },
};

const stepLimits = {
  max: 7,
  min: 1,
} as const;

const stepPlaceholder = (step: number): VehicleAssignmentStep => ({
  description: uiText.placeholder.description,
  icon: CarIcon,
  step,
  title: uiText.placeholder.title,
});

const stepsAvs: VehicleAssignmentStep[] = [
  stepPlaceholder(1),
  stepPlaceholder(2),
  {
    description: uiText.steps.clientInfo.description,
    icon: UserIcon,
    step: 3,
    title: uiText.steps.clientInfo.title,
  },
  stepPlaceholder(4),
  stepPlaceholder(5),
  stepPlaceholder(6),
  stepPlaceholder(7),
];

function VehicleAssignmentAvsFlow() {
  const { handleStepChange, step } = useStep();
  const [canProceed, setCanProceed] = useState(true);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-4 gap-8">
        <div className="col-span-1">
          <VehicleAssignmentStepProgress currentStep={step} steps={stepsAvs} />
        </div>

        <div className="col-span-3">
          <VehicleAssignmentAvsSteps onCanProceedChange={setCanProceed} />
          <StepNavigation
            isNextDisabled={step === 3 ? !canProceed : false}
            onNext={() => handleStepChange(Math.min(step + 1, stepLimits.max))}
            onPrevious={() =>
              handleStepChange(Math.max(step - 1, stepLimits.min))
            }
            showNext={step < stepLimits.max}
            showPrevious={step > stepLimits.min}
          />
        </div>
      </div>
    </div>
  );
}

export { VehicleAssignmentAvsFlow };
